import { useMemo } from 'react'

import { useAppSelector } from 'reduxTyped'
import { useGetPermissionHref } from 'common/core/hooks/permissions/useGetPermissionHref'
import {
  getAccountErrorRefreshPermissionActions,
  getManualRefreshPermissionActions,
  RefreshPermissionsAction,
} from 'common/core/lib/refreshPermissions'
import { getRefreshPermissionsData } from 'common/core/selectors/refreshPermissionsSelectors'
import { isTestEnv } from 'utils/e2e'

export type RefreshPermissionsMode = 'manual' | 'account-error'

export type RefreshPermissionsLinkAction = RefreshPermissionsAction & {
  href: string
}

export const useRefreshPermissionActions = (
  mode: RefreshPermissionsMode,
): RefreshPermissionsLinkAction[] => {
  const data = useAppSelector(getRefreshPermissionsData)
  const { getPermissionHref } = useGetPermissionHref()

  return useMemo(() => {
    if (mode === 'account-error' && isTestEnv()) return []

    const availableActions =
      mode === 'manual'
        ? getManualRefreshPermissionActions(data)
        : getAccountErrorRefreshPermissionActions(data)

    return availableActions.map((action) => ({
      ...action,
      href: getPermissionHref(action.permissionType),
    }))
  }, [data, getPermissionHref, mode])
}
